module.exports = __webpack_public_path__ + "img/game_icon_down.66fc5da3.png";